import { render, staticRenderFns } from "./PaymentOptions.vue?vue&type=template&id=6cc22522&scoped=true&"
import script from "./PaymentOptions.vue?vue&type=script&lang=js&"
export * from "./PaymentOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc22522",
  null
  
)

export default component.exports